export enum HttpStatusCode {
  movedPermanently = 301,
  badRequest = 400,
  unauthorized = 401,
  forbidden = 403,
  notFound = 404,
  teaPot = 418,
  unprocessedEntity = 422,
}
